import PotentialCustomerChartUI from "features/Report/PotentialCustomerChartUI";
import React from "react";

const PotentialCustomerReport = () => {
  return <PotentialCustomerChartUI />;
};

export default PotentialCustomerReport;
